import { actionTypes, mutationTypes } from '@/core/constants'
import api from '@/core/apiclient'
import { DataUtils, DownloadFile } from '@/core/utils'

export default {
	async [actionTypes.ATA.BUSCAR_POR_ID]({ commit }, idAta) {
		const { data } = await api.ata.buscarPorId(idAta)
		commit(mutationTypes.ATA.SET_INFORMACOES_ATA, data)
		return data
	},
	async [actionTypes.ATA.BUSCAR_POR_FILTRO]({ state }) {
		const {
			idOrgao,
			idAtividadeAdesao,
			idAtividadePedido,
			filtro: { atividadeAdesao, atividadePedido, ...filtro },
			paginacao,
		} = state

		const { data } = await api.ata.buscarAtasPorFiltro(
			{ idOrgao, idAtividadeAdesao, idAtividadePedido, ...filtro },
			paginacao,
		)
		return data
	},
	async [actionTypes.ATA.BUSCAR_ATIVIDADES_FILTRO](context) {
		const { data } = await api.ata.buscarAtividadesFiltro()
		return data
	},

	async [actionTypes.ATA.BUSCAR_ATAS_COLLAPSES_ADESOES]({ state }, objFiltro) {
		const { atividadeAdesao, atividadePedido, ...filtro } = objFiltro.filtro

		const idAtividadeAdesao = state.idAtividadeAdesao
		const idAtividadePedido = state.idAtividadePedido
		const idOrgao = state.idOrgao

		const filtroAtividades = {}

		if (idAtividadeAdesao) filtroAtividades.idAtividadeAdesao = idAtividadeAdesao
		if (idAtividadePedido) filtroAtividades.idAtividadePedido = idAtividadePedido

		const { data } = await api.ata.buscarAtasCollapses(
			{ ...filtroAtividades, ...filtro, idOrgao },
			objFiltro.paginacao,
		)

		return data
	},

	async [actionTypes.ATA.INSERIR_POR_PROCESSO](context, objt) {
		objt['inicioValidade'] = DataUtils.setDateTimeOffSetFromLocaleDate(new Date().toLocaleDateString('pt-BR'))
		const { data } = await api.ata.inserirAtaComProcesso(objt)
		return data
	},

	async [actionTypes.ATA.ATUALIZAR_ATA_COM_PROCESSO]({ getters, commit }, idContratado) {
		const { informacoesAta } = getters
		const { data } = await api.ata.atualizarAtaComProcesso({ idContratado, ...informacoesAta })
		commit(mutationTypes.ATA.SET_INFORMACOES_ATA, data)
		return data
	},

	async [actionTypes.ATA.BLOQUEAR_ATA]({ commit }, { idAta: idAta, justificativa: justificativa }) {
		await api.ata.bloquearAta(idAta, justificativa)
		commit(mutationTypes.ATA.SET_BLOQUEIO_ATA, true)
	},

	async [actionTypes.ATA.DESBLOQUEAR_ATA]({ commit }, { idAta: idAta, justificativa: justificativa }) {
		await api.ata.desbloquear(idAta, justificativa)
		commit(mutationTypes.ATA.SET_BLOQUEIO_ATA, false)
	},

	async [actionTypes.ATA.CANCELAR_ATA](context, { idAta, motivo }) {
		await api.ata.cancelarAta(idAta, motivo)
	},

	async [actionTypes.ATA.EXCLUIR](context, { idAta }) {
		await api.ata.deletarPorId(idAta)
	},

	async [actionTypes.ATA.SALVAR_NUMERO_ATA](context, { idAta, numero }) {
		await api.ata.salvarNumeroAta(idAta, numero)
	},

	async [actionTypes.ATA.EFETIVAR_ATA](context, idAta) {
		await api.ata.efetivarAta(idAta)
	},

	async [actionTypes.ATA.BAIXAR_MODELO_IMPORTAR_PREV_CONSUMO](context, idAta) {
		const response = await api.ata.baixarModeloImportarPrevConsumo(idAta)
		const headers = response.headers
		DownloadFile.downloadRawArrayBuffer(response.data, headers.filename, headers['content-type'])
	},

	async [actionTypes.ATA.VERIFICAR_PLANILHA_IMPORTADA_PARA_ORGAO](context, { idAta, idPlanilhaImportacao }) {
		const { data } = await api.ata.verificarPlanilhaImportadaParaOrgao(idAta, idPlanilhaImportacao)
		return data
	},

	async [actionTypes.ATA.GERAR_MODELO_IMPORTAR_PREV_CONSUMO](context, idAta) {
		await api.ata.gerarModeloImportarPrevConsumo(idAta)
	},

	async [actionTypes.ATA.IMPORTAR_CONSUMO](context, objParam) {
		await api.ata.importarConsumo(objParam)
	},

	async [actionTypes.ATA.ENVIAR_ATA_PARA_PNCP](context, idAta) {
		await api.ata.enviarAtaParaPncp(idAta)
	},

	async [actionTypes.ATA.EXCLUIR_ATA_NO_PNCP](context, idAta) {
		await api.ata.excluirAtaNoPncp(idAta)
	},

	async [actionTypes.ATA.REENVIAR_ATA_PARA_DETALHAMENTO](context, idAta) {
		await api.ata.reenviarAtaParaDetalhamento(idAta)
	},

	async [actionTypes.ATA.BUSCAR_DATA_PRORROGACAO](context, idAta) {
		const { data } = await api.ata.buscarDataProrrogacao(idAta)
		return data
	},

	async [actionTypes.ATA.PRORROGAR_ATA](context, { idAta, novaData }) {
		const { data } = await api.ata.prorrogarAta(idAta, novaData)
		return data
	},

	async [actionTypes.ATA.BUSCAR_ORGAOS_FILTRO](context, campoBusca) {
		const { data } = await api.ata.buscarOrgaosAtaFiltro({ campoBusca })
		return data
	},

	async [actionTypes.ATA.BUSCAR_CONTRATADOS]({ commit }, idAta) {
		const { data } = await api.ata.buscarContratados(idAta)
		commit(mutationTypes.ATA.SET_LISTA_CONTRATADOS, data)
		return data
	},

	async [actionTypes.ATA.BUSCAR_ORGAOS_PARTICIPANTES](context, idAta) {
		const { data } = await api.ata.buscarOrgaosParticipantesDaAta(idAta)
		return data
	},
}
